<template>
  <div id="graphic-static-country">
    <ipub-row :gutter="20"
              style="margin-bottom:20px">
      <ipub-col :span="4">
        <div class="flex">
          <span class="line-h-40 ipub-p2 fw-bd">Journal</span>
          <ipub-select v-model="params.journalId"
                       placeholder="Select Journal"
                       class="mar-l-20"
                       @change="getVolumeCode"
                       :options="journalList" />
        </div>
      </ipub-col>
      <ipub-col :span="4">
        <div class="flex">
          <span class="line-h-40 ipub-p2 fw-bd">Volume</span>
          <ipub-select class="mar-l-20"
                       placeholder="Select Volume"
                       v-model="params.volumeId"
                       optionTitle="code"
                       @change="getIssueCode"
                       :options="volumeList" />
        </div>
      </ipub-col>
      <ipub-col :span="4"
                class="flex">
        <span class="line-h-40 nowrap ipub-p2 fw-bd">Status</span>
        <ipub-select v-model="params.status"
                     @change="getData"
                     class="mar-l-12"
                     :clear="true"
                     placeholder="Select Article Status">
          <template v-for="(value, key) in Status">
            <ipub-select-option :key="key"
                                :value="key">
              {{ value }}
            </ipub-select-option>
          </template>
        </ipub-select>
      </ipub-col>
      <!-- <ipub-col :span="4">
        <div class="flex">
          <span class="line-h-40">Issue</span>
          <ipub-select class="mar-l-20"
                       placeholder="Select Issue"
                       optionTitle="code"
                       :disabled="!params.volumeId"
                       @change="getList"
                       v-model="params.issueId"
                       :options="issueList" />
        </div>
      </ipub-col> -->
    </ipub-row>
    <div class="flex relative mar-b-20">
      <div class="ipub-p1"
           v-show="user.codeList&&user.codeList.includes('STATISTICS.GRAPHICAL_ANALYSIS.COUNTRY.EXPORT')">
        <ipub-button type="primary"
                     @click="exp">
          Export Journal Data
        </ipub-button>
      </div>
      <div class="ipub-p1 mar-b-20 right-option line-h-40">Data Update time: {{zoneArticalNumber.createTime && $moment(zoneArticalNumber.createTime).format('HH:mm:ss DD / MM / YYYY')}}</div>
    </div>

    <div class="mar-b-20">
      <!-- <artical-number :params="params"
                      :issueList="issueList"></artical-number> -->
      <div id="artical-number">
        <div class="ipub-h2 mar-b-20 flex line-h-40">
          Zone Article Numbers
          <div class="ipub-p1">
            <div class="flex"
                 style="min-width:230px">
              <!-- <span class="line-h-40">Issue</span> -->
              <!-- {{params}} -->
              <ipub-select class="mar-l-20"
                           placeholder="Select Issue"
                           optionTitle="code"
                           :disabled="!params.volumeId"
                           @change="getNumber"
                           v-model="issueId"
                           :options="issueList" />
            </div>
          </div>
        </div>
        <div class="flex artical-number">
          <div class="artical-number-item">
            <div>
              <span class="ipub-h2">{{zoneArticalNumber.oneZoneNum || 0}}</span>
              <div class="ipub-p2">In Zone I</div>

            </div>
          </div>
          <div class="artical-number-item">
            <div>
              <span class="ipub-h2">{{zoneArticalNumber.twoZoneNum || 0}}</span>
              <div class="ipub-p2">In Zone II</div>
            </div>
          </div>
          <div class="artical-number-item">
            <div>
              <span class="ipub-h2">{{zoneArticalNumber.threeZoneNum || 0}}</span>
              <div class="ipub-p2">In Zone III</div>
            </div>
          </div>
          <div class="artical-number-item">
            <div>
              <span class="ipub-h2">{{zoneArticalNumber.totalNum || 0}}</span>
              <div class="ipub-p2">In Total</div>
            </div>
          </div>
          <div class="artical-number-item">
            <div>
              <span class="ipub-h2">{{zoneArticalNumber.chinaNum || 0}}</span>
              <div class="ipub-p2">In China</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <ipub-row :gutter="20">
      <ipub-col :span="7">

      </ipub-col>
      <ipub-col :span="5">

      </ipub-col>
    </ipub-row> -->
    <div class="flex content-row2">
      <div class="line-chart flex mar-b-20">
        <line-chart :params="params"
                    :issueId="issueId"
                    :issueList="issueList"
                    :volumeList="volumeList"></line-chart>
      </div>
      <div id="pie-chart"
           class="flex">
        <div class="pie-chart">
          <div class="ipub-h2 line-h-40 mar-b-10">Zone Pie Chart</div>
          <div class="relative ipub-block">
            <div class="ipub-p1 left-option"
                 style="width:300px">
              <div class="flex"
                   style="min-width:200px">
                <span class="line-h-40">Issue</span>
                <ipub-select class="mar-l-20"
                             placeholder="Select Issue"
                             optionTitle="code"
                             :disabled="!params.volumeId"
                             @change="getPie"
                             v-model="
                             issueIdPie"
                             :options="issueList" />
              </div>
            </div>
            <div id="zone-pie-chart"
                 class="flex"
                 style="width:auto;align-items: center;justify-content: center;height:460px">
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
#artical-number {
  .artical-number {
    align-items: center;
    justify-content: space-between;
    &-item {
      display: flex;
      align-items: center;
      width: 19%;
      height: 102px;
      background: $content_color;
      border-radius: 4px;
      padding: 0 12px;
      box-sizing: border-box;
    }
  }
}
</style>

<script>
import main from './main'
export default main
</script>
